const RupeeIcon = ({ clr }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    width={24}
    height={24}
    fill="none"
  >
    <g filter="url(#a)">
      <circle
        cx={13.275}
        cy={10.797}
        r={4.615}
        fill="#FFB834"
        transform="rotate(-29.015 13.275 10.797)"
      />
    </g>
    <foreignObject width={26} height={26} x={0} y={-1}>
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style={{
          backdropFilter: "blur(2px)",
          clipPath: "url(#b)",
          height: "100%",
          width: "100%",
        }}
      />
    </foreignObject>
    <g data-figma-bg-blur-radius={4}>
      <rect width={17} height={17} x={4.5} y={3.5} fill="#F2AE01" rx={8.5} />
      <rect
        width={17}
        height={17}
        x={4.5}
        y={3.5}
        fill="#000"
        fillOpacity={0.2}
        rx={8.5}
      />
      <rect width={17} height={17} x={4.5} y={3.5} stroke="#F5D03B" rx={8.5} />
    </g>
    <path
      fill="#000"
      fillOpacity={0.5}
      d="M12.607 17a21.52 21.52 0 0 0-.728-.949c-.251-.32-.511-.633-.78-.936a26.608 26.608 0 0 0-1.508-1.573v-1.17h1.313c.572 0 1.07-.074 1.495-.221.433-.147.732-.412.897-.793H9.591v-1.157h3.822c-.095-.425-.299-.706-.61-.845a2.468 2.468 0 0 0-1.015-.208H9.591V7.991h6.93l-.222 1.157h-1.794c.165.13.3.286.403.468.104.182.178.377.221.585h.988l-.22 1.157h-.833a2.21 2.21 0 0 1-.637 1.157c-.32.295-.71.52-1.17.676-.46.147-.958.251-1.495.312h-.039c.217.208.45.45.702.728.26.269.524.563.793.884.269.312.524.628.767.949.251.32.477.633.676.936h-2.054Z"
    />
    <defs>
      <clipPath id="b" transform="translate(0 1)">
        <rect width={17} height={17} x={4.5} y={3.5} rx={8.5} />
      </clipPath>
      <filter
        id="a"
        width={68.309}
        height={68.31}
        x={-20.88}
        y={-23.357}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_4264_46490"
          stdDeviation={14.769}
        />
      </filter>
    </defs>
  </svg>
);

export default RupeeIcon;
